/**
 * Résout la cible de navigation pour une notification entreprise.
 * Parcours validation modification : cloche → dispatch / réservations → panneau ouvert.
 */
export const resolveCompanyNotificationLink = ({
  notif,
  dashboardRoot,
  companyPublicId,
}) => {
  const meta = notif?.metadata || {};
  const base = `${dashboardRoot}/company/${companyPublicId}`;
  const bookingId = meta.booking_id;

  // Demande institution (nouvelle ou modifiée) → page Réservations, filtrée sur le jour.
  if (notif.event_type === 'request_updated' || notif.event_type === 'new_request') {
    const params = new URLSearchParams();
    if (meta.mission_date) params.set('date', String(meta.mission_date));
    if (meta.offer_id) params.set('offer', String(meta.offer_id));
    if (meta.request_id) params.set('request', String(meta.request_id));
    if (bookingId) params.set('booking', String(bookingId));
    const query = params.toString();
    return query ? `${base}/reservations?${query}` : `${base}/reservations`;
  }

  if (
    notif.event_type === 'institution_appointment_changed'
    && bookingId
  ) {
    const params = new URLSearchParams({ booking: String(bookingId) });
    params.set('focus', 'schedule_reconfirm');
    if (meta.mission_date) params.set('date', String(meta.mission_date));
    if (meta.appointment_before) params.set('appt_from', String(meta.appointment_before));
    if (meta.appointment_after) params.set('appt_to', String(meta.appointment_after));
    return `${base}/reservations?${params.toString()}`;
  }

  if (bookingId) {
    const params = new URLSearchParams({ booking: String(bookingId) });
    if (
      notif.event_type === 'institution_change_request'
      || meta.change_request_id
      || meta.focus === 'change_request'
    ) {
      params.set('focus', 'change_request');
    }
    return `${base}/dispatch?${params.toString()}`;
  }

  return base;
};
